import React from 'react';
import { howItWorksSteps } from '../../data/mock';
import { Calendar, ClipboardList, MessageCircle } from 'lucide-react';

const stepIcons = [Calendar, ClipboardList, MessageCircle];

const HowItWorksSection = () => {
  return (
    <section
      id="how-it-works"
      className="py-16 sm:py-20 lg:py-24 relative overflow-hidden bg-slate-950"
      data-testid="how-it-works-section"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600/5 rounded-full blur-3xl" aria-hidden="true"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full text-emerald-400 text-sm font-medium mb-4">
            How It Works
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            A Simple, <span className="bg-gradient-to-r from-emerald-400 to-green-400 bg-clip-text text-transparent">Guided Process</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto">
          {howItWorksSteps.map((step, i) => {
            const Icon = stepIcons[i];
            return (
              <div
                key={step.step}
                className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-slate-800 relative"
                data-testid={`how-it-works-step-${step.step}`}
              >
                <div className="absolute -top-4 left-6 bg-gradient-to-r from-blue-600 to-cyan-600 text-white text-sm font-bold w-8 h-8 rounded-full flex items-center justify-center shadow-lg">
                  {step.step}
                </div>
                <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center text-blue-400 border border-blue-500/20 mb-4 mt-2">
                  <Icon className="w-6 h-6" aria-hidden="true" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-3">{step.title}</h3>
                <p className="text-slate-400 text-sm sm:text-base leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
